import React, { useState } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faGrin, faGrinBeam, faFrown } from '@fortawesome/free-solid-svg-icons';
import { Collapse, CardBody, Card } from 'reactstrap';

import { formatCommentDate } from 'utils/date';
import 'assets/scss/components/surveyComments.css';

const getEmoji = experience => {
  let icon = faGrin;
  let color = '#979DA3';

  if (experience === 'negative') {
    icon = faFrown;
    color = 'red';
  } else if (experience === 'positive') {
    icon = faGrinBeam;
    color = 'green';
  }

  return { icon, color };
};

const SurveyAnswerComment = ({ feedback }) => {
  const {
    id,
    comment,
    survey_experience: surveyExperience,
    survey_user: surveyUser,
    has_contact: hasContact,
    updated_at: created_at,
  } = feedback;
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const {
    first_name: firstName,
    last_name: lastName,
    email,
    age_range: ageRange,
    gender,
    mobile_number: mobileNumber,
  } = surveyUser || {};

  const { color, icon } = getEmoji(surveyExperience);

  return (
    <div className="mt-3 mb-3 survey-comment feedback-list">
      <div className="w-100">
        <Card
          className="bg-white styled-box-shadow d-flex flex-row align-items-center justify-content-between"
          onClick={toggle}
        >
          <div className="d-flex align-self-stretch align-items-center border-right">
            <FontAwesomeIcon
              className="emoji"
              onClick={toggle}
              size="2x"
              color={color}
              icon={icon}
            />
          </div>
          <CardBody className="d-flex flex-row align-items-center justify-content-between">
            <div>
              <div className="comment-text">{comment}</div>
              <div className="comment-timestamp">
                <FontAwesomeIcon className="clock-icon" icon="clock" />{' '}
                {formatCommentDate(created_at)}
              </div>
            </div>
            <FontAwesomeIcon
              opacity={hasContact ? 1 : 0}
              className="contact-icon cursor-pointer"
              onClick={toggle}
              icon="id-card"
            />
          </CardBody>
        </Card>
        <Collapse className="px-3" isOpen={hasContact ? isOpen : false}>
          <Card className="rounded-0 contact-container">
            <span className="chevron-up-icon cursor-pointer" onClick={toggle}>
              <FontAwesomeIcon icon="chevron-circle-up" />
            </span>
            <CardBody>
              <div className="contact-info">
                <span className="name">
                  <FontAwesomeIcon icon="user-alt" />
                  {firstName} {lastName}
                </span>
                <div className="demographics">
                  <span className="mr-1">
                    Age: <b>{ageRange || 'N/A'}</b>
                  </span>
                  <span className="ml-1">
                    Gender: <b>{gender || 'N/A'}</b>
                  </span>
                </div>
              </div>
              <div className="contact-address">
                <div className="email">
                  <FontAwesomeIcon icon="envelope" /> {email || 'N/A'}
                </div>
                <div className="phone">
                  {' '}
                  <FontAwesomeIcon icon="phone" /> {mobileNumber || 'N/A'}
                </div>
              </div>
            </CardBody>
          </Card>
        </Collapse>
      </div>
    </div>
  );
};

const FeedbackList = ({ feedbacks }) => {
  if (feedbacks.length === 0) {
    return (
      <div className="p-5 text-center w-100">
        You have not received any participant feedback
      </div>
    );
  }

  const feedbacksList = feedbacks.map(feedback => (
    <SurveyAnswerComment key={feedback.id} feedback={feedback} />
  ));
  return <div className="w-100">{feedbacksList}</div>;
};

export default FeedbackList;



// WEBPACK FOOTER //
// ./src/components/feedbackReport/feedbackList.js